

/* -----------------------------------------------------------------------------------------------------
  - Created: [20-02-2025] by [SREERAJ]
  - Modified: [YYYY-MM-DD] 
------------------------------------------------------------------------------------------------------- */

import React, { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid2';
import { useFormik } from 'formik';
import CustomSelectDropdown from '../../../Components/custom_components/CustomSelectDropdown/CustomSelectDropdown';
import ActionButton from '../../../Components/custom_components/CustomButtons/ActionButton/ActionButton';
import CustomBreadcrumbs from '../../../Components/custom_components/CustomBreadcrumbs/CustomBreadcrumbs';
import CustomTextFieldWithIcon from '../../../Components/custom_components/custom_text_field/CustomTextFieldWithIcon';
import CustomDatePicker from '../../../Components/custom_components/CustomDatePicker/CustomDatePicker';
import dayjs from 'dayjs';
import { sourceOptions } from '../../../utils/constants';
import { get_module_and_event_values } from '../../../config/GeneralApis/GeneralApis';

function AuditLogSearchFilter({
    tableTitle,
    searchFilter, on_change_value, on_page_count_update
}) {



    const [moduleOptions, setModuleOptions] = useState([]);
    const [eventOptions, setEventOptions] = useState([]);

    useEffect(() => {
        fetchDropdownData();
    }, []);

    const fetchDropdownData = async () => {
        try {
            const params = {};
            // Call the API to get module and event values
            const response = await get_module_and_event_values(params);
            const data = response?.data || [];

            // Convert them into dropdown-friendly arrays
            const moduleArr = data?.affected_module.map(mod => ({ label: mod, value: mod }));
            const eventArr = data?.event_done.map(evt => ({ label: evt, value: evt }));

            setModuleOptions(moduleArr);
            setEventOptions(eventArr);
        } catch (error) {
            console.error("Error fetching dropdown data:", error);
        }
    };

    const formik = useFormik({
        initialValues: {

            affected_module: '',
            affected_area: '',
            event_done: '',
            source: '',

            start_date: '',
            end_date: '',
        },
        // onSubmit: values => {
        //     searchFilter(values);
        // },
    });

    const resetFilter = () => {
        formik.resetForm();
        on_change_value(1)
        on_page_count_update(25)
        searchFilter({
            affected_module: '',
            affected_area: '',
            event_done: '',
            source: '',

            start_date: '',
            end_date: '',
        })
    };
    const breadcrumbs = ["AuditLog", tableTitle];
    return (
        <div className="common-search-filter-container">
            <div className="common-search-filter-sub-container">
                <div className="common-search-header">
                    <div className="common-search-left">
                        <div className="common-table-title">{tableTitle}</div>
                        <CustomBreadcrumbs breadcrumbs={breadcrumbs} />
                    </div>
                    <div className="common-search-right">
                        {/* Add button can go here if needed */}
                    </div>
                </div>

                <Grid container spacing={3} alignItems="center">


                    <Grid item xs={12} sm={6} md={3}>
                        <CustomTextFieldWithIcon
                            name="affected_area"
                            placeholder="Search by Affected Area"
                            value={formik.values.affected_area}
                            onChange={formik.handleChange}
                            width="100%"
                        />
                    </Grid>


                    <Grid item xs={12} sm={6} md={3}>
                        <CustomSelectDropdown
                            name="affected_module"
                            placeholder="Select Module"
                            options={moduleOptions}
                            value={moduleOptions.find(opt => opt.value === formik.values.affected_module) || ''}
                            onChange={opt => formik.setFieldValue('affected_module', opt?.value || '')}
                            onBlur={formik.handleBlur}
                            isMulti={false}
                            width="200px"
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} md={3}>
                        <CustomSelectDropdown
                            name="event_done"
                            placeholder="Select Event"
                            options={eventOptions}
                            value={eventOptions.find(opt => opt.value === formik.values.event_done) || ''}
                            onChange={opt => formik.setFieldValue('event_done', opt?.value || '')}
                            onBlur={formik.handleBlur}
                            isMulti={false}
                            width="200px"
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} md={3}>
                        <CustomSelectDropdown
                            name="source"
                            placeholder="Select Source"
                            options={sourceOptions}
                            value={sourceOptions.find(opt => opt.value === formik.values.source) || ''}
                            onChange={opt => formik.setFieldValue('source', opt?.value || '')}
                            onBlur={formik.handleBlur}
                            isMulti={false}
                            width="200px"
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} md={3}>
                        <CustomDatePicker
                            name="start_date"
                            label="From Date"
                            onChange={(date) => {
                                formik.setFieldValue("start_date", date);
                                const selectedDate = dayjs(date, "DD-MM-YYYY");
                                const endDate = dayjs(formik.values.end_date, "DD-MM-YYYY");
                                if (endDate.isBefore(selectedDate)) {
                                    formik.setFieldValue("end_date", "");
                                }
                            }}
                            onBlur={formik.handleBlur}
                            value={dayjs(formik.values.start_date, "DD-MM-YYYY")}
                            width="200px"
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} md={3}>
                        <CustomDatePicker
                            name="end_date"
                            label="End Date"
                            onChange={(date) => {
                                formik.setFieldValue("end_date", date);
                            }}
                            onBlur={formik.handleBlur}
                            value={dayjs(formik.values.end_date, "DD-MM-YYYY")}
                            width="200px"
                            minDate={
                                formik.values.start_date
                                    ? dayjs(formik.values.start_date, "DD-MM-YYYY")
                                    : undefined
                            }
                        />
                    </Grid>

                    <Grid item xs={12} sm={12} md={3}>
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <ActionButton
                                    onClick={() => {
                                        on_change_value(1)
                                        searchFilter({ ...formik.values }); // Always trigger search, even if no values changed
                                    }}
                                    btnDisable={false}
                                    label="Search"
                                    btnType="primary"
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <ActionButton
                                    onClick={resetFilter}
                                    label="Reset"
                                    btnType="outlined"
                                    fullWidth
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </div>
        </div>
    );
}

export default AuditLogSearchFilter;